// extracted by mini-css-extract-plugin
export default {"billSide":"BillSide_billSide__vmO4O","wrap":"BillSide_wrap__ciRTx","button":"BillSide_button__a0b3u","error":"BillSide_error__HeW0B"};